import Fuse from 'fuse.js'
import { useAtomValue } from 'jotai'
import { useListingsState } from '../services/context/ListingsContext'
import { Listing } from '../services/getListings'
import { customerFavoriteListings } from '../utils/atoms'
import { useMemo } from 'react'

import { useDebounce } from 'use-debounce'

const useListingFiltered = (listings: Listing[]): Listing[] => {
  const { state: listingsState } = useListingsState()

  const { priceMin, priceMax, bedsMin, bathsMin, address, favorites } = listingsState

  const [debouncedAddress] = useDebounce(address, 500)

  const favoriteListingIds = useAtomValue(customerFavoriteListings).map(e => e.id)

  const filterApplied =
    priceMin ||
    priceMax ||
    bedsMin > 0 ||
    bathsMin > 0 ||
    favorites

  let filteredListings = useMemo(() => {
    if (!debouncedAddress) {
      return listings
    }

    const fuse = new Fuse(listings, {
      ignoreLocation: true,
      threshold: 0.1,
      keys: ['address'],
    })

    return fuse.search(debouncedAddress).map((option) => option.item);
  }, [listings, debouncedAddress]);

  if (filterApplied) {
    filteredListings = filteredListings.filter(({ id, beds, baths, list_price }) => {
      if (priceMin && list_price < priceMin) {
        return false
      }

      if (priceMax && list_price > priceMax) {
        return false
      }

      if (beds < bedsMin || baths < bathsMin) {
        return false
      }

      if (favorites && !favoriteListingIds.includes(id)) {
        return false
      }

      return true
    })
  }

  return filteredListings
}

export default useListingFiltered
